import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ProgressCircle } from '@americanexpress/dls-react';
import { FormattedMessage } from 'react-intl';
import { createAnalyticsData } from '../../utils';

const Interstitial = ({ analyticsData, track }) => {
  useEffect(() => {
    const { product = {} } = analyticsData;
    const data = {
      element: 'Processing',
      detail: '',
      product,
      meta: {
        conversionStep: undefined,
      },
    };
    track(createAnalyticsData(data));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <section className="dls-white-bg pad-4-b pad-4-t">
      <div id="spinner" className="pad-4-t pad-4-b flex flex-justify-center flex-align-items-center">
        <ProgressCircle size="lg" />
      </div>
      <div className="flex pad-1-t text-align-center pad-2-l pad-2-r flex-justify-center flex-align-items-center heading-4">
        <FormattedMessage id="interstitial.spinner.label1" default="interstitial.spinner.label1" />
      </div>
      <div className="flex pad-2-b text-align-center pad-2-l pad-2-r flex-justify-center flex-align-items-center heading-4">
        <FormattedMessage id="interstitial.spinner.label2" />
      </div>
    </section>
  );
};

Interstitial.propTypes = {
  analyticsData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ])).isRequired,
  track: PropTypes.func.isRequired,
};

export default Interstitial;
